import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";

/**
 * Legacy /auth/callback route — kept for backwards-compat after the
 * Sec-S9 cookie migration.  The backend's /api/auth/google/callback now
 * sets the HttpOnly session cookie *before* redirecting to /workflows
 * directly, so this page should almost never be hit.  When it IS hit
 * (e.g. an older browser tab with the legacy redirect URL bookmarked),
 * we just refresh the user from /api/auth/me and forward to /workflows.
 */
export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [params] = useSearchParams();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const error = params.get("error");
      if (error) {
        navigate(`/login?error=${encodeURIComponent(error)}`, { replace: true });
        return;
      }
      const user = await refreshUser();
      if (cancelled) return;
      if (user) {
        navigate("/workflows", { replace: true });
      } else {
        navigate("/login?error=session_lost", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, refreshUser, params]);

  return (
    <div
      data-testid="auth-callback"
      className="grid min-h-screen place-items-center text-sm text-slate-500"
    >
      Signing you in…
    </div>
  );
}
